export const PROJECTILE_FIRE_INTERVAL=.2;
export const PROJECTILE_FIRE_CAPACITY=2;
export const PROJECTILE_MAX_ACTIVE_PER_OWNER=20;

export function canFireProjectile(vehicle,activeCount=0){
  const available=Number.isFinite(vehicle?.projectileFireTokens)
    ?vehicle.projectileFireTokens
    :PROJECTILE_FIRE_CAPACITY;
  return Boolean(
    vehicle
    &&!vehicle.disabled
    &&available>=1
    &&Math.max(0,Number(activeCount)||0)<PROJECTILE_MAX_ACTIVE_PER_OWNER
  );
}

export function consumeProjectileFire(vehicle){
  if(!vehicle)return false;
  const available=Number.isFinite(vehicle.projectileFireTokens)
    ?vehicle.projectileFireTokens
    :PROJECTILE_FIRE_CAPACITY;
  if(available<1)return false;
  vehicle.projectileFireTokens=Math.max(0,available-1);
  return true;
}

export function tickProjectileFireLimiter(vehicle,dt){
  if(!vehicle)return;
  vehicle.projectileFireTokens=Math.min(
    PROJECTILE_FIRE_CAPACITY,
    Math.max(0,Number.isFinite(vehicle.projectileFireTokens)
      ?vehicle.projectileFireTokens
      :PROJECTILE_FIRE_CAPACITY),
  );
  if(vehicle.projectileFireTokens>=PROJECTILE_FIRE_CAPACITY){
    vehicle.projectileFireRecharge=0;
    return;
  }
  vehicle.projectileFireRecharge=Math.max(0,Number(vehicle.projectileFireRecharge)||0)
    +Math.max(0,Number(dt)||0);
  const recovered=Math.floor((vehicle.projectileFireRecharge+.000001)/PROJECTILE_FIRE_INTERVAL);
  if(recovered<=0)return;
  vehicle.projectileFireTokens=Math.min(
    PROJECTILE_FIRE_CAPACITY,
    vehicle.projectileFireTokens+recovered,
  );
  vehicle.projectileFireRecharge=vehicle.projectileFireTokens>=PROJECTILE_FIRE_CAPACITY
    ?0
    :Math.max(0,vehicle.projectileFireRecharge-recovered*PROJECTILE_FIRE_INTERVAL);
}
